// extracted by mini-css-extract-plugin
export var cardContainer = "_n8-0";
export var cardHeader = "_n8-2";
export var collapsedState = "_n8-3";
export var dragHandle = "_n8-5";
export var dragHandleIcon = "_n8-6";
export var dragging = "_n8-1";
export var titleArea = "_n8-4";